module.exports = __webpack_public_path__ + "img/Beta_Torre_de_Control.af2a06a7.svg";